import { Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { FormsModule } from '@angular/forms';
import { BaseAbstractPage } from '@incust-mobile/core';

@Component({
  selector: 'app-main-page',
  templateUrl: 'main.page.html',
  styleUrls: ['main.page.scss'],
  standalone: true,
  imports: [IonicModule, FormsModule]
})
export class MainPage extends BaseAbstractPage implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
